import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpinstance } from "../../axios/api";

export const getcustomercategorylist = createAsyncThunk('getcustomercategorylist', async (value,{rejectWithValue, signal}) => {
    try {
        const url = `/markup/categoryMarkup`;
        // Forward the thunk's abort signal so callers can truly cancel the
        // request (e.g. leaving the ocean results page via Edit Query).
        const response = await httpinstance.get(url, { signal });
        return response.data.data;
    } catch (err) {
        // Let RTK handle aborts; guard err.response for networkless errors.
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') throw err;
        return  rejectWithValue(err?.response?.data);
    }
});

// Async thunk for creating markup
export const createmarkup = createAsyncThunk('createmarkup', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/minimumMarkup`;
        const response = await httpinstance.post(url, value);
        return response.data;
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});

// Async thunk for fetching airlines list
export const getAirlinesList = createAsyncThunk('getAirlinesList', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/listAirlines`;
        const response = await httpinstance.get(url);
        return response.data.data.map((element) => {
            return {
                _id: element._id,
                code: element.carr_code,
                name: element.carr_name,
                logo: element.logoLocation
            }
        });
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});

// Async thunk for fetching airlines list from the /api/airlines_list endpoint.
// Returns entries keyed by carrier code (carr_code), which is what the manual
// quote carrier dropdowns currently display.
export const getAirlinesListByCode = createAsyncThunk('getAirlinesListByCode', async (value,{rejectWithValue}) => {
    try {
        const url = `/airlines_list`;
        const response = await httpinstance.get(url);
        return response.data.data.map((element) => {
            return {
                _id: element._id,
                carr_name: element.carr_name,
                carr_code: element.carr_code
            }
        });
    } catch (err) {
        return  rejectWithValue(err?.response?.data);
    }
});

// Async thunk for fetching airport list
export const getAirportList = createAsyncThunk('getAirportList', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/listAirport`;
        const response = await httpinstance.get(url);
        return response.data.data;
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});


// Async thunk for fetching ODCC strategies list
export const getOdccStrategiesList = createAsyncThunk('getOdccStrategiesList', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/listOdccStrategies${value}`;
        const response = await httpinstance.get(url);
        return response.data.data;
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});


// Async thunk for calculating markup
export const calculateMarkup = createAsyncThunk('calculateMarkup', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/calculateMarkup`;
        const response = await httpinstance.post(url, value);
        return response.data;
    } catch (err) {
        
        return  rejectWithValue(err.response.data);
    }
});
// Initial state



// Async thunk for creating ODCC markup
export const createOdccMarkup = createAsyncThunk('createOdccMarkup', async (value, { rejectWithValue }) => {
    try {

        const url = `/markup/odccMarkup`;
        const response = await httpinstance.post(url, value);
        console.log(response.data)
        return response.data;
    } catch (err) {
        
      return  rejectWithValue(err.response.data);
    }
});

// Async thunk for updating minimum markup
export const updateMinimumMarkup = createAsyncThunk('updateMinimumMarkup', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/minimumMarkup`;
        const response = await httpinstance.put(url, value);
        // console.log("update minimum",response.data)
        return response.data;
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});


export const updateOdccMarkup = createAsyncThunk('updateOdccMarkup', async (value, { rejectWithValue }) => {
    try {
        const url = `/markup/odccMarkup`;
        const response = await httpinstance.put(url, value);
        return response.data;
    } catch (err) {
        console.log(err, 'errror response')
        return rejectWithValue(err.response.data);
    }
});
export const deleteODCSMarkup = createAsyncThunk('deleteODCSMarkup', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/deleteOdccStrategies`;
        const response = await httpinstance.patch(url, value);
        return response.data;
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});


// Async thunk for updating customer category markup
export const updateCustomerCategoryMarkup = createAsyncThunk('updateCustomerCategoryMarkup', async (value, { rejectWithValue }) => {
    try {
        const url = `/markup/categoryMarkup`;
        const response = await httpinstance.put(url, value);
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response.data);
    }
});


export const getMinimumMarkupList = createAsyncThunk('getMinimumMarkupList', async (value,{rejectWithValue}) => {
    try {
        const url = `/markup/listMinMarkup`;
        const response = await httpinstance.get(url);
        return response.data.data[0];
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});

export const get_booking_markup = createAsyncThunk('get_booking_markup', async (queryId,{rejectWithValue}) => {
    try {
        const url = `markup/booking_markup/${queryId}`;
        const response = await httpinstance.get(url);
        return response.data
    } catch (err) {
        return  rejectWithValue(err.response.data);
    }
});


const initialState = {
    loading: false,
    success: "",
    customerCategory: [],
    listOfAirline: [],
    listOfAirport: [],
    listOfOdccStrategies: [],
    markupCalculationResult: null,
    minimumMarkup: null,
    error: ''
};

// Markup slice
const markupSlice = createSlice({
    name: 'organization',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getcustomercategorylist.fulfilled, (state, { payload }) => {
                state.customerCategory = payload;
            })
            .addCase(getAirlinesList.fulfilled, (state, { payload }) => {
                state.listOfAirline = payload;
            })
            .addCase(getAirportList.fulfilled, (state, { payload }) => {
                state.listOfAirport = payload;
            }).addCase(getOdccStrategiesList.fulfilled, (state, { payload }) => {
                state.listOfOdccStrategies = payload;
            }).addCase(calculateMarkup.fulfilled, (state, { payload }) => {
                state.markupCalculationResult = payload;
            }).addCase(calculateMarkup.rejected, (state, { payload }) => {

                return {
                    ...state,
                    loading: false,
                    payload

                }
            })

            .addCase(createOdccMarkup.fulfilled, (state, { payload }) => {
                state.markupCalculationResult = payload;
            }).addCase(createOdccMarkup.rejected, (state, { payload }) => {
                return {
                    ...state,
                    loading: false,
                    error: payload
                }
            }).addCase(updateMinimumMarkup.fulfilled, (state, { payload }) => {
                state.minimumMarkup = payload;
            })
            .addCase(updateOdccMarkup.fulfilled, (state, { payload }) => {
                return { ...state, loading: false, markupCalculationResult: payload };

            })
            .addCase(updateOdccMarkup.rejected, (state, { payload }) => {
                return { ...state, loading: false, error: payload };
            })

            .addCase(updateCustomerCategoryMarkup.fulfilled, (state, { payload }) => {
            })
            .addCase(updateCustomerCategoryMarkup.rejected, (state, { payload }) => {
                state.loading = false;
                state.payload = payload;
            }).addCase(getMinimumMarkupList.fulfilled, (state, { payload }) => {
                state.minimumMarkup = payload;
            })
            .addCase(getMinimumMarkupList.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            }).addCase(deleteODCSMarkup.fulfilled, (state, { payload }) => {

            })
            .addCase(deleteODCSMarkup.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            });
    },
});

// Export reducer
export default markupSlice.reducer;
